import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-bubble-message",
  "use": "icon-si-glyph-bubble-message-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-si-glyph-bubble-message\">\n    <g stroke=\"none\" stroke-width=\"1\" fill-rule=\"evenodd\">\n        <path d=\"M8.988,1.002 C4.601,1.002 1.041,3.621 1.041,6.854 C1.041,9.804 4.009,12.237 7.865,12.64 L5.823,15.972 L11.926,12.286 C14.86,11.426 16.938,9.319 16.938,6.853 C16.938,3.621 13.379,1.002 8.988,1.002 L8.988,1.002 Z\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-bubble-message.svg
// module id = yAEO
// module chunks = 62